import React from "react";
import "./ims.css";
import identityImage from "../../../assets/service-pictures/identity-management-solution.jpg";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import OurApproach from "./OurApproach";
import EnsureSecurity from "./EnsureSecurity";
import IndustriesWeServe from "./IndustriesWeServe";
import Benefits from "./Benefits";
import CallToAction from "./CallToAction";

const IdentityManagementSolutions = () => {
  return (
    <div className="ims-service-wrapper">
      <Particles title="Identity Management Solutions" image={identityImage} />
      <HeroSection />
      <OurApproach />
      <IndustriesWeServe />
      <EnsureSecurity />
      <Benefits />
      <CallToAction />
    </div>
  );
};

export default IdentityManagementSolutions;
